import { Creditor } from '@debbie/common/dist/creditor/index.js'
import { RootState } from '@debbie/cortex/dist/reducer.js'
import CaseVoucherTable from '@debbie/iris/dist/components/CaseVoucherTable.js'
import {
  Content,
  PageBase,
  Panel,
  TopNav,
} from '@debbie/iris/dist/components/index.js'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { styled } from 'styled-components'

type Props = {}

const CaseVouchers = (props: Props) => {
  const selectedCreditor = useSelector((s: RootState) => s.selectedCreditor)

  return (
    <>
      <TopNav />
      <Content withSubMenu>
        <PageBase>
          <Panel>
            <CaseVoucherTable
              pageSize={50}
              filter={{ creditorId: selectedCreditor }}
            ></CaseVoucherTable>
          </Panel>
        </PageBase>
      </Content>
    </>
  )
}

export default CaseVouchers
